export default "<p>sidebar works!</p>\n"